/**
 * TODO: Function return n first initials of userName
 * @param {string} name
 * @param {number} n
 * @returns string
 */
export const initialsString = (name, n = 2) => name.substring(0, n);
